import { ChronoUnitLegacy } from "utils/time-utils";
import { OldDashboardComponent } from "./DashboardComponent";
import { DashboardComponentGroup } from "./DashboardComponentGroup";
import { DashboardTabReportOptions } from "./DashboardReportOptions";

export interface DashboardTabModel {
  uuid: string;
  title: string;
  componentGroups: Array<DashboardComponentGroup>;
  contextConfig?: ContextConfig;
  reportOptions?: DashboardTabReportOptions;
}

export interface OldDashboardTabModel {
  components: Array<OldDashboardComponent>;
  uuid: string;
  title: string;
}

export interface DateLoadConfig {
  timeOffset?: number;
  timeOffsetUnit?: ChronoUnitLegacy;
  lag?: number;
  lead?: number;
  lagUnit?: ChronoUnitLegacy;
  leadUnit?: ChronoUnitLegacy;
  alignStartTo?: ChronoUnitLegacy;
}
export interface ContextConfig {
  contextType?: ContextTypes;
  showBorders?: boolean;
  referenceTime?: string;
  config?: DateLoadConfig;
}

export enum ConfigParameters {
  TIME_OFFSET = "timeOffset",
  TIME_OFFSET_UNITS = "timeOffsetUnits",
  LAG = "lag",
  LAG_UNIT = "lagUnit",
  ALIGN_START_TO = "alignStartTo",
  ALIGN_UNIT = "alignUnit",
}

export enum ConfigTypes {
  CONFIG = "config",
  LOAD_CONF = "loadConf",
}

export enum ContextTypes {
  NONE = "None",
  SINGLE_DATE_SELECTION_WITH_CONFIG = "Single date selection with config",
  RANGE_DATE_SELECTION = "Range date selection",
  SINGLE_DATE_SELECTION = "Single date selection",
}
